import { render, staticRenderFns } from "./EmailClassificationView.vue?vue&type=template&id=20b35bc0"
import script from "./EmailClassificationView.vue?vue&type=script&lang=js"
export * from "./EmailClassificationView.vue?vue&type=script&lang=js"
import style0 from "./EmailClassificationView.vue?vue&type=style&index=0&id=20b35bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports